import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, IcoArchive, IcoDownload, PopoverCentralAjuda, SafeHTML } from '../../../components';
import { CustomLabel, CustomTooltip, RenderLegend, graficoOptions } from './graficoOptions';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { PageLoadView, convertChart } from '../../../helpers';

export default ({ nlsContexto, nls, imprimir }) => {
  const dispatch = useDispatch()
  const { titlePage } = useSelector(state=> state.layoutState)
  const { grafico, graficoLoad } = useSelector(state=> state.npsclienteState)
  const [download, setDownload] = useState(false)

  const idarray = [201];

  const handleDownload = async (e) => {
    setDownload(true)
    const chartdownload = await convertChart({id: 'graficos-chart-box', titlePage})
    setDownload(chartdownload)
  }

  return (
    <>
            <div
        id='graficos-chart-box'
        data-cy='nps-result'
        className={`box-npscliente-graficos box-content ${download?'graficos-download':''}`}
      >
        <div className='graficos-chart-box-action'>
                    <PopoverCentralAjuda
            cy='help'
            nlsContexto={nlsContexto}
            idarray={idarray}
          />
                    {!graficoLoad ? (
            <Button
              data-cy='chart-download'
              type='btn circle'
              color='primary'
              variant='outlined'
              onClick={()=> handleDownload()}
              title={nls.downloadgrafico}
            >
              <IcoDownload />
            </Button>
          ) : null}
        </div>
                <div
          id='graficos-chart'
          data-cy='nps-chart'
          className="box-npscliente-graficos-chart"
        >
          <h3>{titlePage}</h3>
          <PageLoadView
            load={graficoLoad} 
            data={grafico.data}
            semdadosparaexibir={!imprimir ? nls.semdadosparaexibir : null}
          >
          {imprimir ? (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                width={graficoOptions.BarChart.width}
                height={graficoOptions.BarChart.height}
                data={grafico.data}
                margin={graficoOptions.BarChart.margin}
              >
                <CartesianGrid
                  stroke={graficoOptions.CartesianGrid.stroke} 
                  vertical={graficoOptions.CartesianGrid.vertical} 
                />
                <XAxis 
                  dataKey={graficoOptions.XAxis.dataKey} 
                  stroke={graficoOptions.XAxis.stroke} 
                  axisLine={graficoOptions.XAxis.axisLine} 
                  tickLine={graficoOptions.XAxis.tickLine} 
                  fontSize={graficoOptions.XAxis.fontSize} 
                />
                <YAxis 
                  unit={graficoOptions.YAxis.unit} 
                  stroke={graficoOptions.YAxis.stroke} 
                  axisLine={graficoOptions.YAxis.axisLine} 
                  tickLine={graficoOptions.YAxis.tickLine} 
                  fontSize={graficoOptions.YAxis.fontSize} 
                />
                <Tooltip content={<CustomTooltip labels={grafico.labels} msgNA={nls.Dadonaodisponivel}/>} />
                <Legend content={<RenderLegend  labels={grafico.labels} />} />
                {
                  grafico.labels?.map((label, i)=> <Bar 
                    key={`bar-${label.type}-${i}`}
                    dataKey={label.type} 
                    fill={label.color} 
                    radius={graficoOptions.Bar.radius} 
                    label={<CustomLabel />}
                  />)
                }
              </BarChart>
            </ResponsiveContainer>
          ) : null}
          </PageLoadView>

        </div>
      </div>
      {
        imprimir && grafico.analiseGrafica?
                <div
          className='box-npscliente-analise-grafica box-content'
          data-cy='nps-analysis'
        >
          <h3><IcoArchive/>  {nls.analise}</h3>

          {/* Substituído dangerouslySetInnerHTML pelo componente SafeHTML */}
          <SafeHTML html={grafico.analiseGrafica} />
        
        </div>
        :null
      }
    </>
  )
}
